import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterNumberValue,
  UniversalFilterNumberModes,
  UniversalFilterNumberFilterOptions,
  UniversalFilterNumberOnChange
} from './UniversalFilterNumber.types';

import { useUniversalFilterNumber } from './hooks/useUniversalFilterNumber';

import { UniversalFilterNumberInput } from '../../helpers/UniversalFilterNumberInput';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterNumberProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterNumberValue;
  i18nName: I18nText;
  options?: UniversalFilterNumberFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterNumberOnChange;
}

function UniversalFilterNumber({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterNumberProps) {
  const { modeOptions, filterState, handleModeChange, handleValueChange } =
    useUniversalFilterNumber({
      filterStateCacheKey,
      filterValue,
      options,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterNumberModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterNumberModes.IS,
          UniversalFilterNumberModes.IS_NOT,
          UniversalFilterNumberModes.IS_EMPTY,
          UniversalFilterNumberModes.IS_NOT_EMPTY,
          UniversalFilterNumberModes.GREATER_THAN_EQUAL,
          UniversalFilterNumberModes.LESS_THAN_EQUAL
        ],
        filterState.mode
      ) ? (
        <UniversalFilterNumberInput
          key={filterState.mode}
          value={filterState.value}
          autoFocus={autoFocus}
          onChange={handleValueChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterNumber;
